import { fromJS } from "immutable";
import * as ActionTypes from '../../actions/types'
import { Menu } from "../../components/app/layout/menuItems/menuItems";

const INITIAL_STATE = {
	openItem: ['group-dashboard'],
	selectedID: "group-dashboard",
	drawerOpen: true,
	selectedItems: '',
	selectedLevel: 0,
	menuItems: [],
	menu: {}
}

function setMenu(state, action) {
	const { payload } = action
	return state
	.set('menu', payload.menu)
}

function setMenuItems(state, action) {
	const { payload } = action
	let getMenu = Menu(state.get('menu')?.toJS());
	const isFound = payload.some((element) => {
		return element.id === 'group-dashboard';
	});
	
	if (getMenu?.id !== undefined && !isFound) {
		payload.splice(0, 0, getMenu);
	}
	
	return state
	.set('menuItems', fromJS(payload))
}

function setSelectedLevel(state, action) {
	const { payload } = action
	return state
	.set('selectedLevel', payload)
}

function setSelectedItems(state, action) {
	const { payload } = action
	return state
	.set('selectedItems', payload)
}

function setMenuActiveItem(state, action) {
	const { payload } = action
	return state
	.set('openItem', payload.openItem)
}

function setMenuActiveId(state, action) {
	const { payload } = action
	return state
	.set('selectedID', payload)
}

function setDrawerOpen(state, action) {
	const { payload } = action
	return state
	.set('drawerOpen', payload)
}

const menu = {
	initialState: INITIAL_STATE,
	handlers: {
		[ActionTypes.SET_MENU]: setMenu,
		[ActionTypes.SET_MENU_ITEMS]: setMenuItems,
		[ActionTypes.SET_MENU_ACTIVE_ITEM]: setMenuActiveItem,
		[ActionTypes.SET_MENU_ACTIVE_ID]: setMenuActiveId,
		[ActionTypes.SET_MENU_SELECTED_ITEMS]: setSelectedItems,
		[ActionTypes.SET_MENU_SELECTED_LEVEL]: setSelectedLevel,
		[ActionTypes.SET_DRAWER_OPEN]: setDrawerOpen,
		
	}
}

export default menu
